export enum Language {
  bokmal = 'nb',
  nynorsk = 'nn',
  ibexaBokmal = 'nor-NO',
  ibexaNyNorsk = 'nno-NO',
}

export default Language
